<template>
  <td class="part-number-cell"
      :class="{ 'is-widget': isWidget }">
    <strong>
      <span class="part-number-value">
        <component  :is="isWidget ? 'span' : 'router-link'"
                    :to="{ path: getNewDetailsPath() }"
                    :class="{ 'has-text-info': bomItem.highlight,
                              'has-text-link': hasWidgetInfoLandingPage,
                              'pointer-on-hover': hasWidgetInfoLandingPage }"
                    @click="handlePartInfoRedirect">
           {{ bomItem.partNumber }}
        </component>
        <button v-if="!isWidget && showPartNumber"
                class="button is-small ml-2 copy-part-number-btn"
                :class="{ 'has-text-primary-invert': bomItem.highlight,
                          'has-text-link': !bomItem.highlight }"
                  data-testid="copy-bom-part-number"
                  @click.stop.prevent="copyPartNumber">
          <span class="icon far fa-copy fa-lg copy-part-number-icon"
                  :class="{ 'has-text-primary-invert': bomItem.highlight }" />
        </button>
      </span>
    </strong>
  </td>
</template>

<script>
import { handlePartInfoRedirect } from './compositionObjects'
export default {
  name: 'BomCellPartNumber',
  emits: ['openWidgetPartInfo'],
  props: {
    bomItem: {
      type: Object,
      required: true
    },
    column: {
      type: Object,
      required: false
    },
    isWidget: Boolean,
    hasWidgetInfoLandingPage: Boolean
  },
  computed: {
    showPartNumber () {
      return !!this.bomItem?.partNumber
    }
  },
  methods: {
    getNewDetailsPath() {
      return this.bomItem.pagePartUrl + '/details'
    },
    copyPartNumber () {
      navigator.clipboard.writeText(this.bomItem.partNumber)
      this.$notify({
        type: 'success',
        title: this.$t('success'),
        text: this.$t('partNumberCopied', { label: this.$t('partNumber') })
      })
    },
    open () {
      this.$emit('open', {
        content: this.bomItem,
        route: ''
      })
    },
    ...handlePartInfoRedirect
  }
}
</script>

<style scoped>
.table tr.is-selected a, .table tr.is-selected strong {
  color: currentColor !important;
}

.part-number-cell {
  min-width: 7.0rem;
}

.part-number-cell.is-widget {
  min-width: 5.5rem;
}

.part-number-value {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
}

.copy-part-number-btn {
  padding: 0;
  background-color: transparent !important;
  border: 0;
  box-shadow: none !important;
}

.copy-part-number-btn:hover,
.copy-part-number-btn:active,
.copy-part-number-btn:focus {
  background-color: transparent !important;
  box-shadow: none !important;
}

.copy-part-number-icon {
  font-size: 0.7rem;
  color: currentColor !important;
}

.table tr.is-selected .copy-part-number-btn,
.table tr.is-selected .copy-part-number-icon {
  color: currentColor !important;
}
</style>
